import { render, staticRenderFns } from "./AiTriageHostPage.vue?vue&type=template&id=3b5ff951&scoped=true&"
import script from "./AiTriageHostPage.vue?vue&type=script&lang=js&"
export * from "./AiTriageHostPage.vue?vue&type=script&lang=js&"
import style0 from "./AiTriageHostPage.vue?vue&type=style&index=0&id=3b5ff951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ff951",
  null
  
)

export default component.exports